<template>
  <v-dialog 
      max-width="500"
      transition="dialog-bottom-transition"
      scrollable
      persistent
      :value="dialog"
    >
      <template>

  <v-card>

    <v-card-title>
        Extra Fields for {{editedItem.name}} <v-icon>{{editedItem.icon}}</v-icon>
        <v-spacer/>
        <v-icon color="gray" @click="close()">
                    close
        </v-icon>
    </v-card-title>
    <v-simple-table>
    <template v-slot:default>
      <thead>
        <tr>
          <th class="text-left">
            Field Name
          </th>
          <th class="text-left">
            Field Type
          </th>
          <th class="text-left">
            Actions
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="item in editedItem.categoryExtraFields"
          :key="item.id"
        >
          <td>{{ item.fieldName.originalText}}</td>
          <td>{{ item.fieldType }}</td>
          <td>
            <v-icon small class="mr-2 center" color="error" @click="deleteField(item)"> delete </v-icon>
          </td>
        </tr>
        <tr v-if="addNew">
            <td>
                <v-text-field 
                placeholder="Field Name"
                v-model="fieldName">

                </v-text-field>
            </td>
            <td>
                <v-select 
                placeholder="Field Type" 
                v-model="fieldType" 
                :items="items" 
                item-text="type"
                item-value="code">
                </v-select>
            </td>
            <td>
              <div>
                <v-icon small  color="error" @click="cancelField">
                    close
                </v-icon>
                <v-icon small class="ml-2" color="green" @click="addField()">
                    done
                </v-icon>
              </div>
            </td>
        </tr>
      </tbody>
    </template>
  </v-simple-table>
  <v-card-actions>
    <v-btn color="primary"  @click="addNew = true">
                <v-icon>add</v-icon> Add Field
    </v-btn>
    <v-spacer/>
    <v-btn color="error" @click="close()">
                close
    </v-btn>
  </v-card-actions>
  </v-card>
  
  
  
</template>
    </v-dialog>
</template>

<script>
import { mapActions} from "vuex";

export default {
    name:"Extra",
    props:{
        dialog: Boolean,
        editedItem: Object
    },
    data: () => ({
        fieldName: "",
        fieldType: "",
        items: [
          { type: 'int', code: '0' },
          { type: 'string', code: '1' },
        ],
        addNew: false,

    }),
    methods:{
      ...mapActions({addExtraField: "category/addExtraField"}),
      ...mapActions({deleteExtraField: "category/deleteExtraField"}),
        close() {
            console.log("Close is called, categoryExtraFields are:",this.editedItem.categoryExtraFields)
            this.$emit("closed");
    },
        cancelField(){
            this.addNew = false;
            this.fieldName = "";
            this.fieldType = "";
        },
        async addField(){
            console.log("Add Field is called, editedItem is:",this.editedItem)
            console.log("Field to be added is: name=",this.fieldName + " " +" type = " + this.fieldType)
            var returnVal = await this.addExtraField({
              categoryId: this.editedItem.id,
              fieldName: this.fieldName,
              fieldType: this.fieldType,
            });
            console.log("Return Value of addExtraField",returnVal);
            this.addNew = false;
            this.fieldName = "";
            this.fieldType = "";
            this.fieldsChanged();
        },
        async deleteField(id){ 
            console.log("DeleteField is called with id = ", id)
            console.log("Edited item's id is = ", this.editedItem.id);
            await this.deleteExtraField(id,this.editedItem.id)
            this.fieldsChanged();            
        },
        fieldsChanged(){
          console.log("Fields Changed is called in ExtraField.vue")
          this.$emit("fieldsChanged")
        }

    },
    watch:{
        // dialog(newVal,oldVal){
        //     console.log("New Val",newVal);
        //     console.log("Old Val",oldVal);
        // }
    }
}
</script>

<style>

</style>